<template>
    <ProgressBar :value="value" :mode="mode?'indeterminate':'determinate'" :showValue="showText" style="position: absolute; width: 400px;" />
</template>

<script>
import ProgressBar from 'primevue/progressbar';

export default {
    name: 'tw-ws-progress',
    components: {
        ProgressBar
    },
    props: {
        value: {
            type: Number,
            default: 50
        },
        mode: {
            type: Boolean,
            default: false
        },
        showText: {
            type: Boolean,
            default: true
        }
    }
}
</script>
